const BANK_CODES = {
  "004": "국민은행",
  "011": "농협은행",
  "088": "신한은행",
  "020": "우리은행",
  "003": "기업은행",
  "081": "하나은행",
  "090": "카카오뱅크",
  "092": "토스뱅크",
  "089": "케이뱅크",
  "023": "제일은행",
  "027": "씨티은행",
  "045": "새마을금고",
  "279": "DB증권",
  "218": "KB증권",
  "265": "LS증권",
  "247": "NH투자증권",
  "103": "SBI저축은행",
  "266": "SK증권",
  "031": "iM뱅크",
  "262": "iM증권",
  "039": "경남은행",
  "034": "광주은행",
  "261": "교보증권",
  "267": "대신증권",
  "287": "메리츠증권",
  "238": "미래에셋증권",
  "290": "부국증권",
  "032": "부산은행",
  "064": "산림조합",
  "002": "산업은행",
  "240": "삼성증권",
  "007": "수협은행",
  "030": "수협중앙회",
  "291": "신영증권",
  "278": "신한투자증권",
  "048": "신협",
  "071": "우체국",
  "209": "유안타증권",
  "280": "유진투자증권",
  "050": "저축은행",
  "037": "전북은행",
  "035": "제주은행",
  "012": "지역농축협",
  "288": "카카오페이증권",
  "264": "키움증권",
  "271": "토스증권",
  "270": "하나증권",
  "243": "한국투자증권",
  "294": "한국포스증권",
  "269": "한화투자증권",
  "263": "현대차증권",
};

export function getBankName(code) {
  if (!code) return '-';
  return BANK_CODES[String(code)] || code;
}
